﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListNachricht extends GuiListGeneric {
    constructor() {
        super("Nachricht");

    }

}


